import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RelatedEvents = ({ events, currentEventId }) => {
  const filteredEvents = events?.filter(event => event?.id !== currentEventId);

  if (filteredEvents?.length === 0) {
    return null;
  }

  return (
    <section className="mt-12">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-2xl font-bold text-foreground">You Might Also Like</h3>
        <Button variant="outline" size="sm" asChild>
          <Link to="/event-discovery">View All Events</Link>
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredEvents?.slice(0, 3)?.map((event) => (
          <Link
            key={event?.id}
            to={`/event-details?id=${event?.id}`}
            className="group block"
          >
            <div className="bg-card border border-border rounded-lg overflow-hidden transition-all hover:shadow-md hover:border-primary/50">
              {/* Event Image */}
              <div className="relative h-48 overflow-hidden">
                <Image
                  src={event?.images?.[0]}
                  alt={event?.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 bg-primary text-primary-foreground text-xs font-medium rounded-full">
                    {event?.category}
                  </span>
                </div>
                {event?.featured && (
                  <div className="absolute top-3 right-3">
                    <span className="px-2 py-1 bg-warning text-black text-xs font-medium rounded-full">
                      Featured
                    </span>
                  </div>
                )}
              </div>
              
              {/* Event Content */}
              <div className="p-4">
                <h4 className="font-semibold text-foreground mb-2 line-clamp-2 group-hover:text-primary transition-colors">
                  {event?.title}
                </h4>
                
                <div className="space-y-2 mb-3">
                  <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                    <Icon name="Calendar" size={14} />
                    <span>{event?.date}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                    <Icon name="MapPin" size={14} />
                    <span>{event?.venue?.name}</span>
                  </div>
                </div>
                
                {/* Price Range */}
                <div className="flex items-center justify-between">
                  <div className="text-sm text-muted-foreground">
                    Starting from
                  </div>
                  <div className="font-semibold text-foreground">
                    ${Math.min(...event?.tiers?.map(tier => tier?.price))?.toFixed(2)}
                  </div>
                </div>
                
                {/* Availability */}
                <div className="mt-2 flex items-center justify-between text-xs">
                  <span className="text-muted-foreground">
                    {event?.totalCapacity - event?.bookedSeats} spots left
                  </span>
                  <div className="flex items-center space-x-1">
                    <Icon name="Users" size={12} className="text-muted-foreground" />
                    <span className="text-muted-foreground">{event?.attendeeCount} going</span>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedEvents;